import type { NonNullableFormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';
import {
  type ControlInterface,
  dateValidator,
  enumValidator,
  getXYearInThePastDate,
  maxDateValidator,
  minDateValidator,
} from '@comparit/core';
import { Beschaeftigungsart, Geschlecht, type Step7FormInput } from '../../../interfaces';

export class Step7Form {
  constructor(
    private fb: NonNullableFormBuilder,
    private defaultValue?: Step7FormInput | null
  ) {}

  ctrls: ControlInterface<Step7FormInput> = {
    // The Versicherungsnehmer signs the contract, so the Geburtsdatum has to be an adult's.
    geburtsdatum: this.fb.control<string>(this.defaultValue?.geburtsdatum ?? '', [
      Validators.required,
      dateValidator(),
      minDateValidator(getXYearInThePastDate(100)),
      maxDateValidator(getXYearInThePastDate(18)),
    ]),
    geschlecht: this.fb.control<Geschlecht | null>(this.defaultValue?.geschlecht ?? null, [
      Validators.required,
      enumValidator(Geschlecht),
    ]),
    beschaeftigungsart: this.fb.control<Beschaeftigungsart | null>(
      this.defaultValue?.beschaeftigungsart ?? null,
      [Validators.required, enumValidator(Beschaeftigungsart)]
    ),
  };

  public fg = this.fb.group(this.ctrls);
}
